import "../scss/resort-menu.scss";

/* Resort Sub Menu */
jQuery( "#ResortSubMenuButtonOpen" ).click(function() {
    jQuery( "#ResortSubMenuButtonOpen" ).hide();
    jQuery( "#ResortSubMenuButtonClose" ).show(600);
});

jQuery( "#ResortSubMenuButtonClose" ).click(function() {
    jQuery( "#ResortSubMenuButtonClose" ).hide();
    jQuery( "#ResortSubMenuButtonOpen" ).show(600);
});
